import Spacings from "../../../../../../packages/design-system/src/Spacings";
import Text from "../../../../../../packages/design-system/src/Text";
import Collapsible from "../../../../../../packages/design-system/src/Collapsible";
import * as React from 'react';
export default {
  Spacings,
  Text,
  Collapsible,
  React
};